<router-outlet>
</router-outlet>
<!-- <app-navbar *ngIf="!(location == '/coming-soon' || location == '/' || location == '/gym-coaching' || location == '/profile-authentication' || location == '/reset-password' || location == '/andorra-documentos' || location == '/andorra-apply' || location == '/oferta-trabajo-gral')">
</app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/coming-soon' || location == '/profile-authentication' )"></app-footer>
<ngx-scrolltop></ngx-scrolltop> -->